<script>
    import { onMount } from "svelte";
    export let isSpinner = true;
    let Shadow = null;

    onMount(async () => {
        if (typeof window !== "undefined") {
            const mod = await import("svelte-loading-spinners");
            Shadow = mod.Shadow;
        }
    });
</script>

{#if isSpinner && Shadow}
    <div class="spinner-overlay">
        <svelte:component this={Shadow} size="60" color="#FED500" unit="px" duration="1.3s" />
    </div>
{/if}

<style>
    .spinner-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.25); /* полупрозрачный фон */
        z-index: 9999;
    }
</style>
